import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from 'src/app/shared/helpers/utils';
import { formatToBRL } from '../formatters';
import addPeriods from '../helpers/addPeriods';


@Pipe({ name: 'BOOLEAN' })
export class BooleanPipe implements PipeTransform {

	transform(value: Boolean): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		return value ? 'Sim' : 'Não';
	}

}

@Pipe({ name: 'MOEDA_BR' })
export class MoedaBrPipe implements PipeTransform {

	transform(value: number, removeZero?: boolean): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const valor = formatToBRL(value);
		return removeZero ? valor.replace(',00', '') : valor;
	}

}

@Pipe({ name: 'PERCENTUAL' })
export class PercentualPipe implements PipeTransform {

	transform(value: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const number = Number(value).toFixed(2).replace('.', ',');
		return addPeriods(number) + '%';
	}

}

@Pipe({ name: 'INTEIRO' })
export class InteiroPipe implements PipeTransform {

	transform(value: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const number = Number(value).toFixed(0).replace('.', ',');
		return addPeriods(number);
	}

}

@Pipe({ name: 'NUMERO' })
export class NumeroPipe implements PipeTransform {

	transform(value: number, fractionDigits?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const number = Number(value).toFixed(fractionDigits || 2).replace('.', ',');
		return addPeriods(number);
	}

}
